import {action} from 'typesafe-actions'
import {Comment} from '@models/comment'
import {RequestData} from "@models/axios";

export const enum CommentsActionTypes {
    FETCH_REQUEST = '@@Comments/FETCH_REQUEST',
    FETCH_SUCCESS = '@@Comments/FETCH_SUCCESS',
    FETCH_ERROR = '@@Comments/FETCH_ERROR',

    UPDATE_REQUEST = '@@Comments/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@Comments/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@Comments/UPDATE_ERROR',
}


export const fetchRequest = (data: RequestData) => action(CommentsActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Comment[]) => action(CommentsActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(CommentsActionTypes.FETCH_ERROR, message);

export const updateRequest = (data: RequestData) => action(CommentsActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: RequestData) => action(CommentsActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(CommentsActionTypes.UPDATE_ERROR, message);
